// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PolicyTypeWithPCData__tooltip{transform:translate(8px,2px)}.app__PolicyTypeWithPCData__imType{vertical-align:text-bottom}", "",{"version":3,"sources":["webpack://./../common/wni-ce/capabilities-react/gwce-capability-claim-react-ext/components/PolicyTypeWithPCData/PolicyTypeWithPCData.module.scss"],"names":[],"mappings":"AAAA,oCACE,4BAAA,CAGF,mCACE,0BAAA","sourcesContent":[".tooltip {\n  transform: translate(8px, 2px);\n}\n\n.imType {\n  vertical-align: text-bottom;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "app__PolicyTypeWithPCData__tooltip",
	"imType": "app__PolicyTypeWithPCData__imType"
};
export default ___CSS_LOADER_EXPORT___;
